export const THEME_INITIAL_STATE = {
  primary: '#5EC5BA',
  secondary: '#033E63',
};
export const SET_THEME = 'SET_THEME';
